import { Text } from '@change/ds-core-ui';
import { SparkleIcon } from '@change/ds-icons';

import { Separator } from '@change-corgi/design-system-legacy/components/content';

type TargetPetitionAssociationData = Readonly<{
	isAutoAdded: boolean | null;
	addedToPetitionAt: string | null;
	daysSinceNotified: number | null;
}>;

type Props = Readonly<{
	targetPetitionAssociationData: TargetPetitionAssociationData | null;
}>;

export function AutoAddLabel({ targetPetitionAssociationData }: Props): React.JSX.Element | null {
	const isAutoAdded = !!targetPetitionAssociationData?.isAutoAdded;
	const addedToPetitionAt = targetPetitionAssociationData?.addedToPetitionAt
		? new Date(targetPetitionAssociationData.addedToPetitionAt).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			})
		: null;

	return isAutoAdded ? (
		<div className="flex-start flex gap-2 self-stretch border-0 border-t border-solid border-t-stroke-weaker pt-3">
			<Separator role="presentation" mt={8} sx={{ color: 'neutral-grey100' }} />
			<SparkleIcon className="icon-strong h-[20px] w-[20px]" />
			<Text variant="body" size="small" className="text-typography-strong">
				Automatically added on {addedToPetitionAt}
			</Text>
		</div>
	) : null;
}
